import { GridEventListener, GridRowEditStopReasons } from '@mui/x-data-grid';
import { useCallback } from 'react';

export const useHandleRowEditStop = (): GridEventListener<'rowEditStop'> => {
  return useCallback((params, event) => {
    if (params.reason !== GridRowEditStopReasons.rowFocusOut) return;
    event.defaultMuiPrevented = true;
  }, []);
};
